import React, { useMemo } from 'react';
import { MPN10_SYMPTOMS } from '../../data/diseasesData';
import { useUserInput } from '../../context/UserInputContext';

const Mpn10Questionnaire: React.FC = () => {
  const { state, update } = useUserInput();
  const symptoms = state.mpn10.symptoms;

  const setSymptom = (index: number, value: string) => {
    // Only allow 0–10
    if (value !== '' && !/^\d{1,2}$/.test(value)) return;
    const num = parseInt(value, 10);
    if (!isNaN(num) && num > 10) return;

    const next = [...symptoms];
    next[index] = value;
    update('mpn10', { symptoms: next });
  };

  const { total, filledCount } = useMemo(() => {
    let sum = 0;
    let count = 0;
    for (const s of symptoms) {
      const val = parseInt(s, 10);
      if (!isNaN(val)) {
        sum += val;
        count += 1;
      }
    }
    return { total: sum, filledCount: count };
  }, [symptoms]);

  return (
    <div className="mpn10-form">
      <header className="mpn10-form__header">
        <h3 className="mpn10-form__title">MPN-10 Symptom Score</h3>
        <p className="mpn10-form__subtitle">
          Rate each symptom from 0 (absent) to 10 (worst imaginable)
        </p>
      </header>

      <div className="mpn10-form__list">
        {MPN10_SYMPTOMS.map((symptom, i) => (
          <div className="mpn10-form__item" key={i}>
            <label className="mpn10-form__label">
              <span className="mpn10-form__number">{i + 1}</span>
              <span className="mpn10-form__name">
                {symptom.en}
                {symptom.hint && (
                  <span className="mpn10-form__hint">{symptom.hint}</span>
                )}
              </span>
            </label>
            <div className="mpn10-form__input-wrap">
              <input
                type="text"
                inputMode="numeric"
                className="mpn10-form__input"
                value={symptoms[i] || ''}
                onChange={(e) => setSymptom(i, e.target.value)}
                placeholder="0–10"
                autoComplete="off"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mpn10-form__total">
        <span className="mpn10-form__total-label">
          Total ({filledCount}/{MPN10_SYMPTOMS.length} answered)
        </span>
        <span className="mpn10-form__total-value">{total}/100</span>
      </div>
    </div>
  );
};

export default Mpn10Questionnaire;
